module.exports = __webpack_public_path__ + "img/Logo-Eagle.e0df4fb5.png";